export enum FeedbackActionType {
  CREATE_FAILURE_CLIENT = '@@feedback/CREATE_FAILURE_CLIENT',
  CREATE_REQUEST_CLIENT = '@@feedback/CREATE_REQUEST_CLIENT',
  CREATE_SUCCESS_CLIENT = '@@feedback/CREATE_SUCCESS_CLIENT',
  TOGGLE_FEEDBACK_DRAWER = '@@feedback/TOGGLE_FEEDBACK_DRAWER',
}
